export const API_URL =
  process.env.REACT_APP_API_ENV === "production"
    ? "https://api.asteride.co/api/v1/"
    : "https://dev-api.asteride.co/api/v1/";